<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
               matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          <span>
            <a *ngIf="hasEditAccess" [routerLink]="[detailsUrl, 'edit', row.id]">
              {{ row.name }}
            </a>
            <span *ngIf="!hasEditAccess">{{ row.name }}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isEnabled">
        <mat-header-cell *matHeaderCellDef mat-sort-header="isEnabled">Enabled</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Enabled:</span>
          <span>{{ row.isEnabled | yesno }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sourceName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="sourceName">Report Source</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Report Source:</span>
          {{row.sourceDescription}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="scheduleText">
        <mat-header-cell *matHeaderCellDef mat-sort-header="scheduleText">Schedule</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Schedule:</span>
          {{row.scheduleText}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nextRecurringDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="nextRecurringDate">Next Recurring Date</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Next Recurring Date:</span>
          {{ row.nextRecurringDate | dateTime: 'M/dd/yyyy hh:mm a' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button type="button" mat-icon-button matTooltip="Download Report" [disabled]="isDownloadInProgress(row.id)"
                  (click)="onDownload(row.id, customReportsService.allDataSourcesMap[row.sourceName] || row.sourceName)">
            <mat-icon *ngIf="!isDownloadInProgress(row.id)">download</mat-icon>
            <mat-progress-spinner mode="indeterminate" diameter="24" *ngIf="isDownloadInProgress(row.id)"></mat-progress-spinner>
          </button>

          <button type="button" mat-icon-button matTooltip="Send Report" (click)="onPreview(row.id)" [disabled]="isPreviewInProgress(row.id)">
            <mat-icon *ngIf="!isPreviewInProgress(row.id)">send</mat-icon>
            <mat-progress-spinner mode="indeterminate" diameter="24" *ngIf="isPreviewInProgress(row.id)"></mat-progress-spinner>
          </button>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
